'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var Column_web = require('./Column/Column.web.cjs');
var Columns_web_styles = require('./Columns.web.styles.cjs');

/**
 * Columns component is used to easily create a grid layout
 *
 * {@link https://aviary.fullscript.io/latest/components/columns/web-h608oYon | Documentation}
 *
 * {@link https://git.fullscript.io/developers/aviary/-/blob/development/packages/aviary-web/src/components/atoms/Columns/Columns.web.tsx | View in GitLab}
 *
 * @scope Web
 *
 * @requires Column (sub-component)
 */ const Columns = ({ children, isMarginless = false, customCss, ...rest })=>{
    const columnsStyles = [
        Columns_web_styles.columns,
        isMarginless && Columns_web_styles.marginless,
        customCss
    ];
    return /*#__PURE__*/ jsxRuntime.jsx("div", {
        css: columnsStyles,
        "data-testid": "aviary-columns",
        ...rest,
        children: children
    });
};
/**
 * A sub-component of Columns, used to create an individual column within a grid layout
 *
 * @scope Web
 *
 * @requires Columns (parent component)
 */ Columns.Column = Column_web.Column;

exports.Columns = Columns;
//# sourceMappingURL=Columns.web.cjs.map
